import React, { Fragment, useContext } from 'react';
import BotonesCuenta from '../barraprincipal/BotonesCuenta';
import FormularioPrincipal from '../tareas/FormularioPrincipal';

import barraprincipalContext from '../../context/barraprincipal/barraprincipalContext';

const ContenedorFormulario = () => {
    
    // Extraer funciones del context
    const barrapplContext = useContext(barraprincipalContext);
    const { vistamenu } = barrapplContext;

    return ( 
        <Fragment>
            {vistamenu ? (
                <BotonesCuenta />
            ) : (
                <FormularioPrincipal />
            )}
        </Fragment>
    );
}
 
export default ContenedorFormulario;